<template>
  <div class="bg-secondary-9 rounded-lg container-border p-4">
    <div class="row">
      <div class="col-12 mb-1">
        <label class="color-gray-7 font-16 font-weight-bold">
          <i class="fas mr-1 fa-times-circle p-1 color-orange font-18" />
          Cancelación de Firmas
        </label>
      </div>
      <div class="col-12 mt-3">
        <label class="data-title mb-0">Razón de Cancelación:</label>
        <custom-text-area
          v-model="model.comment"
          :count-classes="['float-right']"
          :disabled="data.isReadOnly"
          :maxlength="3000"
          placeholder="Ingresa razón"
          show-char-count
        />
      </div>
      <div v-if="!data.isReadOnly" class="col-12 mt-3">
        <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
          <div class="bd-highlight ml-2">
            <action-button
              i="fas fa-save fa-lg"
              text="Guardar"
              variant="success"
              @click="save"
            />
          </div>
          <div class="mx-0">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger"
              @click="cancel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

export default {
  name: 'CancelElectronicSignature',
  components: {
    CustomTextArea,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      comment: null,
    },
  }),
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    save() {
      this.$emit('save', { ...this.model });
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
.container-border {
  border-left: 5px solid #ff7058;
}
</style>
